import { CrmLocalesEnum } from './crm-locales.enum';

export interface CrmLocaleHeaders {
  'X-Lang'?: CrmLocalesEnum;
}
